/**
 * 기본정보 수정
 * 기본정보 취소
 * 추가정보 수정
 * 추가정보 취소
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  rmOdAdInfCreateApi,
  rmOpInfApi,
  rmOpInfCreateApi,
  rmOpModifyApi,
} from "components/api/rm";
// import { UPDATE_BASE_FORM_ID_ROOM_OPTION } from "components/constent";
import { apifield, updated } from "components/utils/comm";
import { getFormData } from "components/utils/comm";
import { FormEvent, useRef } from "react";
import useListRowInfStroe from "store/listRowInf";
import { useOptionAddInfContext } from "./context";
import useLodStore from "store/lod";
import useAlertStore from "store/alert";
import useMultiLangStore from "store/multiLang";
import { IRmOp, rmOpDftInfProps } from "interface/rm/op";
import i18n from "locales/i18n";

type IGetData = {
  modalNm: string;
};
// 상세정보 조회
export const useGetData = ({ modalNm }: IGetData) => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const { isSuccess } = useOptionAddInfContext();
  const baseInfRef = useRef<IRmOp | null>(null);
  const addInfRef = useRef<any[]>([]);

  const params = {
    rmNo: listRowInf.no,
    opRgSeq: listRowInf.rgSeq,
  };

  const { data } = useQuery({
    queryKey: ["room-option-detail", listRowInf.btnNm],
    placeholderData: {
      baseInf: baseInfRef.current,
      addInf: addInfRef.current,
    },

    queryFn: () => {
      return rmOpInfApi(params);
    },
    select: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          baseInfRef.current = data.rmOpDtl;
          addInfRef.current = data.rmOpAddInfList;
        }
        if (code === -1) {
          apifield(message);
        }
        return res;
      }
    },

    enabled: (!!params.opRgSeq && listRowInf.btnNm === modalNm) || isSuccess,
  });

  return {
    baseInf: baseInfRef.current,
    addInf: addInfRef.current,
  };
};

// 기본정보 등록
const useBaseCreateMutate = () => {
  const setListRowParams = useListRowInfStroe(
    (state) => state.setListRowParams
  );
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["room-option-create"],
    mutationFn: rmOpInfCreateApi,
    onSuccess: (res, variables) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          queryClient.invalidateQueries({
            queryKey: ["room-option-detail", listRowInf.btnNm],
          });
          setListRowParams({
            rgSeq: data.rgSeq,
            no: variables.rmNo,
            btnNm: "create",
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

// 기본정보 수정
const useBaseUpdateMutate = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["room-option-update"],
    mutationFn: rmOpModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code == 0) {
          /**
           * 수정 완료후 새로운 상세정보 조회
           * */
          queryClient.invalidateQueries({
            queryKey: ["room-option-detail", listRowInf.btnNm],
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useBaseSubmitForm = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate: updateMutate } = useBaseUpdateMutate();
  const { mutate: createMutate } = useBaseCreateMutate();
  const lod = useLodStore((state) => state.lod);

  const onBaseSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const { type, langcd } = form.dataset;

    // 등록
    if (type === "create") {
      const params = getFormData({ form, type: "C" });

      if (!params.rmNo || !params.latChkOutTi) {
        return onSetAlert({
          isOpen: true,
          inner: "필수입력값을 선택하여 주세요.",
        });
      }

      // 옵션 기본정보 등록

      const param: rmOpDftInfProps = {
        brkfInYn: params.brkfInYn,
        latChkOutTi: params.latChkOutTi,
        rmNo: params.rmNo,
        uyn: params.uynOp || "N",
        lodNo: lod?.lodNo || "",
        rmOpInfList: [],
      };

      createMutate(param);
    }

    // 수정
    if (type === "update") {
      const isUpdate = updated({ form });

      // 수정된 여부 확인
      if (isUpdate) {
        onSetAlert({
          isOpen: true,
          inner: "기본내용을 수정하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            // 수정 api
            const params = getFormData({ form, type: "U" });

            updateMutate({
              ...params,
              rmNo: listRowInf?.no,
              opRgSeq: listRowInf?.rgSeq,
            });
          },
        });
      }
    }
  };

  return { onBaseSubmit };
};

// 추가정보 등록
export const useAddInfcreateMutate = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  // const setListRowParams = useListRowInfStroe(
  //   (state) => state.setListRowParams
  // );
  const resetMultiLang = useMultiLangStore((state) => state.resetMultiLang);
  const { resetDefaultValue } = useOptionAddInfContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["room-option-addInf-create"],
    mutationFn: rmOdAdInfCreateApi,
    onSuccess: (res, variables) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          //등록 성공 후 상세 조회하기
          resetMultiLang();
          resetDefaultValue(variables?.langCd);
          // setListRowParams({
          //   no: variables.rmNo,
          //   rgSeq: data.rgSeq,
          //   btnNm: "create",
          // });
          queryClient.invalidateQueries({
            queryKey: ["room-option-detail", listRowInf.btnNm],
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

// 추가 정보 수정
export const useAddInfUpdateMutate = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const resetMultiLang = useMultiLangStore((state) => state.resetMultiLang);
  const { resetDefaultValue } = useOptionAddInfContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["room-option-addinf-update"],
    mutationFn: rmOpModifyApi,
    onSuccess: (res, variables) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          //수정 성공 후 상세 조회
          resetMultiLang();
          resetDefaultValue(variables?.langCd);
          queryClient.invalidateQueries({
            queryKey: ["room-option-detail", listRowInf.btnNm],
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useAddInfSubmitForm = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate: updateMutate } = useAddInfUpdateMutate();
  const { mutate: careateMutate } = useAddInfcreateMutate();
  const { getDefaultValue } = useOptionAddInfContext();
  const lod = useLodStore((state) => state.lod);

  const onAddInfSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const { type } = form.dataset;

    const langcd = form.id.replace(/^.*-/, "") || i18n.language;

    const data = getDefaultValue(langcd ?? "");
    if (type === "create") {
      let params = getFormData({ form, type: "C" });

      params = {
        ...data,
        ...params,
      };

      if (!(params.rmOpNm && params.rmOpDesc)) {
        return onSetAlert({
          isOpen: true,
          inner: "필수입력값을 입력하여 주세요",
        });
      }
      onSetAlert({
        isOpen: true,
        inner: "추가내용을 등록하시겠습니까?",
        cnclBtn: true,
        onSetConfirm: () => {
          careateMutate({
            ...params,
            rmNo: listRowInf.no,
            lodNo: lod?.lodNo,
            langCd: langcd,
            rgSeq: listRowInf.rgSeq,
          });
        },
      });
    }

    if (type === "update") {
      const isUpdate =
        updated({ form }) ||
        Object.values(data).some(
          (data) => data !== "" && data !== null && data !== undefined
        );

      // 수정된 내용이 없음
      if (!isUpdate) {
        return onSetAlert({
          isOpen: true,
          inner: "수정된 내용이 없습니다.",
        });
      }

      // 수정된 내용이 있음
      if (isUpdate) {
        onSetAlert({
          isOpen: true,
          inner: "추가내용을 수정하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            // 수정 api
            const params = getFormData({ form, type: "U" });

            updateMutate({
              ...data,
              ...params,
              langCd: langcd,
              rmNo: listRowInf?.no,
              opRgSeq: listRowInf?.rgSeq,
            });
          },
        });
      }
    }
  };

  return {
    onAddInfSubmit,
  };
};
